import { UniqueIdentifier } from "@dnd-kit/core";
import {
	AnimateLayoutChanges,
	useSortable,
	defaultAnimateLayoutChanges,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { AccordionItem } from "../../../../../../../types/working-model";
import AccordionContainer, { AccordionContainerProps } from "./accordion-container";

const animateLayoutChanges: AnimateLayoutChanges = (args) => {
	return defaultAnimateLayoutChanges({ ...args, wasDragging: true });
};

function DroppableContainer({
	children,
	columns = 1,
	disabled,
	id,
	items,
	style,
	containerId,
	...props
}: AccordionContainerProps & {
	disabled?: boolean;
	id: UniqueIdentifier;
	items: AccordionItem[];
	style?: React.CSSProperties;
	containerId?: UniqueIdentifier;
}) {

	const {
		active,
		isDragging,
		over,
		setNodeRef,
		transition,
		transform,
	} = useSortable({
		id,
		data: {
			type: "container",
			children: items
		},
		animateLayoutChanges
	});

	const isOverContainer = over
		? (id === over.id && active?.data.current?.type !== "container") ||
		items.find(item => item.id === over.id)
		: false;

	return (
		<AccordionContainer
			ref={disabled ? undefined : setNodeRef}
			style={{
				...style,
				transition,
				transform: CSS.Translate.toString(transform),
				opacity: isDragging ? 0.5 : undefined
			}}
			hover={!!isOverContainer}
			columns={columns}
			containerId={containerId}
			{...props}
		>
			{children}
		</AccordionContainer>
	);
}

export default DroppableContainer;
